import FileHandler from '@tiptap-pro/extension-file-handler';
import { Editor } from '@tiptap/core';

const CustomFileHandler = FileHandler.extend({
  addOptions() {
    const parentOptions = this.parent?.() || {};
    return {
      ...parentOptions,
      onDrop: async (editor: Editor, files: File[], pos: number) => {
        for (const file of files) {
          if (file.type.startsWith('image/')) {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
              editor
                .chain()
                .insertContentAt(pos, {
                  type: 'image',
                  attrs: {
                    src: fileReader.result as string,
                  },
                })
                .focus()
                .run();
            };
          }
          // not yet implemented, waiting for an api to be created
          // else {
          //   // Handle non-image file
          //   const s3Url = await uploadToS3(file);
          //   const fileDate = new Date().toLocaleString('en-US', {
          //     year: 'numeric',
          //     month: 'short',
          //     day: '2-digit',
          //     hour: 'numeric',
          //     minute: 'numeric',
          //     hour12: true,
          //   });

          //   editor
          //     .chain()
          //     .insertContentAt(pos, {
          //       type: 'blockFileCard',
          //       attrs: {
          //         name: file.name,
          //         type: file.type,
          //         size: file.size,
          //         url: s3Url,
          //         date: fileDate,
          //       },
          //     })
          //     .focus()
          //     .run();
          // }
        }

        // Call the original onDrop method if it exists
        if (parentOptions.onDrop) {
          parentOptions.onDrop(editor, files, pos);
        }
      },
      onPaste: async (editor: Editor, files: File[], pasteContent?: string) => {
        if (pasteContent) {
          return false;
        }

        for (const file of files) {
          if (file.type.startsWith('image/')) {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
              editor
                .chain()
                .insertContentAt(editor.state.selection.anchor, {
                  type: 'image',
                  attrs: {
                    src: fileReader.result as string,
                  },
                })
                .focus()
                .run();
            };
          }
          // not yet implemented, waiting for an api to be created
          // else {
          //   // Handle non-image file
          //   const s3Url = await uploadToS3(file);
          //   const fileDate = new Date().toLocaleString('en-US', {
          //     year: 'numeric',
          //     month: 'short',
          //     day: '2-digit',
          //     hour: 'numeric',
          //     minute: 'numeric',
          //     hour12: true,
          //   });

          //   editor
          //     .chain()
          //     .insertContentAt(editor.state.selection.anchor, {
          //       type: 'blockFileCard',
          //       attrs: {
          //         name: file.name,
          //         type: file.type,
          //         size: file.size,
          //         url: s3Url,
          //         date: fileDate,
          //       },
          //     })
          //     .focus()
          //     .run();
          // }
        }

        // Call the original onPaste method if it exists
        if (parentOptions.onPaste) {
          parentOptions.onPaste(editor, files, pasteContent);
        }
      },
    };
  },
});

export default CustomFileHandler;
